<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Firewalls from './firewalls'

export default {
  page: {
    title: 'Firewalls Monitoring',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { Layout, PageHeader, Firewalls },
  data () {
    return {
      title: 'Firewalls',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'Monitoring',
          href: '/monitoring/firewalls'
        },
        {
          text: 'Firewalls',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <Firewalls :base-path="'/monitoring/firewalls'" />
  </Layout>
</template>
